import React, {Context} from "react";
import User from "@/model/User.ts";

export interface IMessageOfTheDay {
    body: string,
    title: string,
    color: string,
    dismissible: string,
    icon: string
}

export interface IOmniEnvironment {
    siteName: string;
    environmentName: string;
    environmentColor: string;
    motd?: IMessageOfTheDay;
    version: string;
    azureAppID: string;
    azureSecretExpireDate: string;
}

export interface IOmniContext {
    setUser: ((user: User) => void) | null;
    user: User | undefined;
    environment: IOmniEnvironment | null;
    refreshEnvironment: (() => void) | null;
}

// @ts-ignore
export const OmniContext: Context<IOmniContext> = React.createContext({
    setUser: null,
    user: undefined,
    environment: null,
    refreshEnvironment: null,
});